import { render, staticRenderFns } from "./HistoryListTile.vue?vue&type=template&id=fa88bf96&scoped=true"
import script from "./HistoryListTile.vue?vue&type=script&lang=js"
export * from "./HistoryListTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa88bf96",
  null
  
)

export default component.exports